import aws from './images/tech/aws.png'
import flask from './images/tech/flask.png'
import gcp from './images/tech/gcp.png'
import python from './images/tech/python.png'
import tensorflow from './images/tech/tensorflow.png'
import pytorch from './images/tech/pytorch.png'
import jupyter from './images/tech/jupyter.png'
import redshift from './images/tech/redshift.png'
import postgresql from './images/tech/psql.png'
import s3 from './images/tech/s3.png'
import docker from './images/tech/docker.png'
import seaborn from './images/tech/seaborn.png'
// import matplotlib from './images/tech/matplotlib.png'
import pandas from './images/tech/pandas.png'
import numpy from './images/tech/numpy.png'
import scikit from './images/tech/scikit.png'
import spark from './images/tech/spark.png'
import bigquery from './images/tech/bigquery.png'
import bigtable from './images/tech/bigtable.png'
import athena from './images/tech/athena.png'
import glue from './images/tech/glue.png'
import kinesis from './images/tech/kinesis.png'
import sagemaker from './images/tech/sagemaker.png'
import bedrock from './images/tech/bedrock.png'
import huggingface from './images/tech/huggingface.png'
import foundationModels from './images/tech/foundation-models.svg'

export const SITE_URL = 'https://captainme.ai';

export const menuLinks = {
  home: '/',
  about: '/about',
  contact: '/contact',
  blog: '/blog',
  portfolio: '/portfolio',
  verticals: '/verticals',
  verticalsEcommerce: '/verticals/e-commerce',
  verticalsAdvertisement: '/verticals/advertisement',
  verticalsRealEstate: '/verticals/real-estate',
  verticalsOthers: '/verticals/others',
  services: '/services',
  servicesDataEngineering: '/services/data-engineering',
  servicesMachineLearning: '/services/machine-learning',
  servicesPredictiveAnalytics: '/services/predictive-analytics-timeseries-data',
  servicesComputerVision: '/services/computer-vision',
  servicesNaturalLanguageProcessing: '/services/natural-language-processing',
  projectETExamples: '/projects/lIlvR9jbBndHw',
  projectETOthers: '/projects/8bY7WsOUcT0ud'
}


export const sections = {
  home: {
    title: 'Home',
    path: menuLinks.home
  },
  about: {
    title: 'About',
    path: menuLinks.about
  },
  contact: {
    title: 'Contact',
    path: menuLinks.contact
  },
  blog: {
    title: 'Blog',
    path: menuLinks.blog
  },
  portfolio: {
    title: 'Portfolio',
    path: menuLinks.portfolio
  },
  services: {
    dataEngineering: {
      title: 'Data Engineering & MLOps',
      path: menuLinks.servicesDataEngineering,
      page: {
        title: 'Extract, Collect, and Transform Big Data at Scale'
      }
    },
    machineLearning: {
      title: 'Machine Learning',
      path: menuLinks.servicesMachineLearning,
      page: {
        title: 'General Machine Learning Approaches'
      }
    },
    predictiveAnalytics: {
      title: 'Predictive Analytics & Agentic Forecasting',
      path: menuLinks.servicesPredictiveAnalytics,
      page: {
        title: 'Intelligent forecasting with autonomous agents and self-healing pipelines'
      }
    },
    computerVision: {
      title: 'Computer Vision & Agentic Visual Intelligence',
      path: menuLinks.servicesComputerVision,
      page: {
        title: 'One-shot detection, action recognition, and intelligent agentic video monitoring'
      }
    },
    naturalLanguageProcessing: {
      title: 'LLM, Agents & Agentic Workflows',
      path: menuLinks.servicesNaturalLanguageProcessing,
      page: {
        title: 'AWS Bedrock, custom LLM fine-tuning, RAG systems, and multi-agent orchestration'
      }
    }
  }
}

export const bestPracticesDefault = [
  'Guarantee Security & Anonnymocy across Data Lakes',
  'Batch and Stream processing of data',
  'Serverless Architecture to minimize cost and manual oversight',
  'Data Compliance and Data Privacy'
]

export const menuTitles = {
  home: 'Home'
}

// Technologies & Frameworks
export const tech = [
  // Cloud Platform
  ['AWS', 'https://aws.amazon.com/', aws],

  // AI/ML Frameworks & Tools
  ['AWS Bedrock', 'https://aws.amazon.com/bedrock/', bedrock],
  ['Hugging Face', 'https://huggingface.co/', huggingface],
  ['Foundation Models', 'https://aws.amazon.com/bedrock/foundation-models/', foundationModels],
  ['PyTorch', 'https://pytorch.org/', pytorch],
  ['Scikit-learn', 'https://scikit-learn.org/stable/', scikit],
  // TODO: Add TorchVision logo to src/images/tech/
  // ['TorchVision', 'https://pytorch.org/vision/', torchvision],

  // AWS AI & Data Services
  ['SageMaker', 'https://aws.amazon.com/sagemaker/', sagemaker],
  ['AWS Athena', 'https://aws.amazon.com/athena/', athena],
  ['AWS Glue', 'https://aws.amazon.com/glue/', glue],
  ['AWS Kinesis', 'https://aws.amazon.com/kinesis/', kinesis],
  ['AWS Redshift', 'https://aws.amazon.com/redshift/', redshift],
  ['AWS S3', 'https://aws.amazon.com/s3/', s3],

  // Data Science & Development
  ['Python', 'https://www.python.org/', python],
  ['Jupyter', 'https://jupyter.org/', jupyter],
  ['Pandas', 'https://pandas.pydata.org/', pandas],
  ['Numpy', 'https://numpy.org/', numpy],
  ['Seaborn', 'https://seaborn.pydata.org/', seaborn],

  // Infrastructure & Processing
  ['Docker', 'https://www.docker.com/', docker],
  ['Apache Spark', 'https://spark.apache.org/', spark],
  ['PostgreSQL', 'https://www.postgresql.org/', postgresql],
  ['Flask', 'https://flask.palletsprojects.com/en/2.2.x/', flask],

  // TODO: Add logos for these AI-focused technologies to src/images/tech/
  // LLM & Agentic AI Frameworks
  // ['LangChain', 'https://www.langchain.com/', langchain],
  // ['LangGraph', 'https://www.langchain.com/langgraph', langgraph],
  // ['LlamaIndex', 'https://www.llamaindex.ai/', llamaindex],

  // Vector Databases & Search
  // ['Pinecone', 'https://www.pinecone.io/', pinecone],
  // ['Weaviate', 'https://weaviate.io/', weaviate],
  // ['ChromaDB', 'https://www.trychroma.com/', chromadb],
  // ['FAISS', 'https://github.com/facebookresearch/faiss', faiss],
  // ['Qdrant', 'https://qdrant.tech/', qdrant],

  // Additional Infrastructure
  // ['Kubernetes', 'https://kubernetes.io/', kubernetes],
  // ['Apache Airflow', 'https://airflow.apache.org/', airflow],
  // ['Apache Spark', 'https://spark.apache.org/', spark],
  // ['Apache Kafka', 'https://kafka.apache.org/', kafka],
  // ['Apache Hive', 'https://hive.apache.org/', hive],
  // ['Apache Hadoop', 'https://hadoop.apache.org/', hadoop],
  // ['Apache Cassandra', 'https://cassandra.apache.org/', cassandra],
  // ['Apache Flink', 'https://flink.apache.org/', flink],
  // ['Apache HBase', 'https://hbase.apache.org/', hbase],
  // ['Apache Pig', 'https://pig.apache.org/', pig],
  // ['Apache Solr', 'https://lucene.apache.org/solr/', solr],
  // ['Apache ZooKeeper', 'https://zookeeper.apache.org/', zookeeper],
  // ['Apache Zeppelin', 'https://zeppelin.apache.org/', zeppelin],
  // ['Apache Superset', 'https://superset.apache.org/', superset],
  // ['Apache NiFi', 'https://nifi.apache.org/', nifi],

]
export const techDescription = 'Our AI-first technology stack combines cutting-edge LLM frameworks (AWS Bedrock, LangChain, LangGraph) with powerful ML tools (PyTorch, TorchVision) and modern vector databases (Pinecone, Weaviate, ChromaDB) for building intelligent agentic systems. We leverage cloud-native AWS architectures to deliver scalable, production-ready AI solutions that handle massive data at scale with minimal manual oversight.'

export default menuLinks;
